import React, { Component } from 'react';
import { Button, Popconfirm, message, Spin } from 'antd';
import UpdateModal from './UpdateWorkHistory';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class WorkHistory extends Component {
    state = {
        data: [],
        loading: true,
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { userId } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.queryVitaeWorkExperienceByUserId,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { data = [] } = res;
                this.setState({
                    data,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getList = (isChinese) => {
        const { data } = this.state;
        const { canEdit } = this.props;
        return (
            data ?
                data.map(item => {
                    const {
                        isCopy,
                        experienceType,
                        workStartTime,
                        workEndTime,
                        workCompany,
                        workCompanyEnglish,
                        workDutyChinese,
                        workDutyEnglish,
                        positionChineseName,
                        positionEnglishName,
                        vitaeWorkExperienceId,
                    } = item;
                    const isJinShi = experienceType === 'MEDKEY' && isCopy === '0';
                    return (
                        <div className="workHistory" key={vitaeWorkExperienceId}>
                            {
                                !(!isChinese && isJinShi) &&
                                <div className="operate">
                                    {
                                        isJinShi &&
                                        <div className="operate-left jinshi">自动</div>
                                    }
                                    {
                                        canEdit &&
                                        <div className="operate-right">
                                            {
                                                isJinShi ?
                                                    <span>
                                                        <a onClick={() => this.update(item, 'copy')}>复制新增</a>
                                                        <span style={{ margin: '0 4px' }}>|</span>
                                                        <a onClick={() => this.update(item, 'edit')}>修改</a>
                                                    </span>
                                                :
                                                    <span>
                                                        <a onClick={() => this.update(item, 'edit')}>修改</a>
                                                        {
                                                            isChinese &&
                                                            <span>
                                                                <span style={{ margin: '0 4px' }}>|</span>
                                                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.delete(vitaeWorkExperienceId)}>
                                                                    <a>删除</a>
                                                                </Popconfirm>
                                                            </span>
                                                        }
                                                    </span>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <div className="head">
                                <div className="head-left need-bold ellipsis">{workStartTime.slice(0, 7)}~{workEndTime ? workEndTime.slice(0, 7) : isChinese ? '至今' : 'Present'}</div>
                                <div className="head-middle need-bold ellipsis" title={isChinese ? workCompany : workCompanyEnglish}>{isChinese ? workCompany : (workCompanyEnglish || <span>&nbsp;</span>)}</div>
                                <div className="head-right need-bold ellipsis" title={isChinese ? `职务：${positionChineseName}` : `Position：${positionEnglishName}`}>{isChinese ? `职务：${positionChineseName}` : `Position：${positionEnglishName}`}</div>
                            </div>
                            <div className="content">
                                <div className="content-head need-bold">{isChinese ? "工作职责" : "Responsibility"}：</div>
                                <pre className="content-text">
                                    {isChinese ? workDutyChinese : workDutyEnglish}
                                </pre>
                            </div>
                        </div>
                    )
                })
            :
                null
        )
    }

    update = (record, isCopy) => {
        this.ref.show(record, isCopy);
    }

    delete = (vitaeWorkExperienceId) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.personal.deleteVitaeWorkExperience,
            data: { vitaeWorkExperienceId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { loading } = this.state; 
        const { userId, canEdit, isChinese } = this.props;
        return (
            <Spin spinning={loading}>
                { canEdit && isChinese && <Button type="primary" onClick={() => this.update({}, 'add')}>新增</Button> }
                { this.getList(isChinese) }
                <UpdateModal ref={el => this.ref = el} userId={userId} isChinese={isChinese} loadData={this.loadData} />
            </Spin>
        );
    }
}

export default WorkHistory;


// WEBPACK FOOTER //
// ./src/components/common/curriculumVitae/WorkHistory.js